import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EditRolePageRoutingModule } from './edit-role-routing.module';

import { EditRolePage } from './edit-role.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EditRolePageRoutingModule,
    BhInputComponentModule,
    PipesModule
  ],
  declarations: [EditRolePage]
})
export class EditRolePageModule {}
